<div class="form-container">
    <ham-modal
        *ngIf="showOptions"
        [saveText]="'aumico_button_save' | i18next"
        [cancelText]="'aumico_button_cancel' | i18next"
        [showCancelButton]="true"
        (cancel)="onCancelOptions()"
        (save)="onCloseOptions()"
    >
        <form [formGroup]="optionsForm" *ngIf="showOptions">
            <div class="form-container__options_wrapper">
                <label class="form-title">{{ 'aumico_notes_select_options' | i18next }} </label>
                <ham-button
                    (buttonClick)="addOption()"
                    icon="assets/hamIcons/plus-outline.svg"
                    variant="transparent"
                    type="submit"
                >
                    {{ 'aumico_button_add' | i18next }}
                </ham-button>
            </div>
            <div formArrayName="options" class="form-container__options_list">
                <div *ngFor="let item of options.controls; let i = index" class="form-container__options">
                    <input
                        hamInput
                        class="checklist-input"
                        [formControl]="item"
                        placeholder="{{ 'aumico_notes_extra_settings_option' | i18next }}"
                    />

                    <span
                        hamIconShapes
                        icon="assets/hamIcons/minus.svg"
                        [variant]="'hamed'"
                        [size]="'xs'"
                        [type]="'circle'"
                        (click)="onRemoveOption(i)"
                    ></span>
                </div>
            </div>
        </form>
        <div class="form-container__actions" *ngIf="showOptions">
            <!-- Error -->
            <label *ngIf="optionsForm.get('options')?.errors?.minlength">
                {{ 'aumico_notes_select_options_min_options' | i18next }}
            </label>
        </div>
    </ham-modal>
</div>
